module.exports = "/assets/data/2f9f10dd99c9297c594e718941bf6173-GL16.data.json";